var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.event.isNext)?_c('hr',{staticClass:"uk-divider-icon"}):_vm._e(),_c('main',{class:[
      'uk-border-rounded',
      'uk-card',
      'uk-flex',
      'uk-flex-column',
      'text-white',
      'uk-margin-bottom',
      _vm.selectColorClass()
    ],staticStyle:{"padding":"5px"}},[_c('div',{staticClass:"uk-text-bold"},[_vm._v(" "+_vm._s(_vm.event.course_name)+" ")]),(_vm.event.teachers !== null)?_c('div',[_vm._v(" "+_vm._s(_vm.event.start_time)+" - "+_vm._s(_vm.event.end_time)+", "+_vm._s(_vm.event.teachers)+" ")]):_c('div',[_vm._v(_vm._s(_vm.event.start_time)+" - "+_vm._s(_vm.event.end_time))])]),(_vm.event.isLast)?_c('hr',{staticClass:"uk-divider-icon",staticStyle:{"margin-top":"10px"}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }